import React from 'react';
import { SkeletonLabel } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './DeliveryOptionSkeleton.styles';

export const DeliveryOptionSkeleton = () => {
  return (
    <div css={styles.deliveryOptionSkeletonWrapper}>
      <SkeletonLabel labelHeight="XL" />
      <SkeletonLabel labelHeight="XL" />
      <SkeletonLabel labelHeight="XL" />
    </div>
  );
};
